/* @flow */
import * as shiftsActions from './actions';
import {fromJS, Record, List} from 'immutable';

const State = Record({
    page: 0,
    limit: 8,
    max: 0,
    shifts: null,
    barmans: List(),
    shift: null,
    showBarmansPopup: false
});

const PAGE = 'page';
const SHIFTS = 'shifts';
const SHIFT = 'shift';
const MAX = 'max';
const BARMANS = 'barmans';
const SHOW_BARMANS_POPUP = 'showBarmansPopup';

const shiftsReducer = (state = new State(), action) => {

    switch (action.type) {
        case shiftsActions.FETCH_BAR_REPORT_SHIFT_BARMANS_START:
        case shiftsActions.FETCH_BAR_REPORT_SHIFT_BARMANS_ERROR: {
            return state.set(BARMANS, List());
        }

        case shiftsActions.OPEN_BAR_REPORT_BARMANS_POPUP: {
            const {open} = action.payload;
            return state
                .set(SHOW_BARMANS_POPUP, open);
        }

        case shiftsActions.FETCH_BAR_REPORT_SHIFT_BARMANS_SUCCESS: {
            const barmans = action.payload.data;
            return state.set(BARMANS, fromJS(barmans));
        }

        case shiftsActions.BAR_REPORT_SHIFTS_POPUP_TYPE: {
            const {shift} = action.payload;
            return state
                .set(SHIFT, shift);
        }

        case shiftsActions.FETCH_BAR_REPORT_SHIFTS_ERROR:
        case shiftsActions.CLEAR_BAR_REPORT_SHIFTS: {
            return state
                .set(SHOW_BARMANS_POPUP, false)
                .set(SHIFT, null)
                .set(PAGE, 0)
                .set(SHIFTS, List())
                .set(MAX, 0);
        }

        case shiftsActions.BAR_REPORT_SHIFT_CHANGE_VALUE_SUCCESS:
        case shiftsActions.PAY_BAR_REPORT_SHIFT_SUCCESS:
        case shiftsActions.BAR_REPORT_SHIFT_CHANGE_BARMAN_SUCCESS:
        case shiftsActions.CLOSE_BAR_REPORT_SHIFT_SUCCESS: {
            const data = fromJS(action.payload.data);
            const index = state.get(SHIFTS).findIndex(shift => shift.get('id') === data.get('id'));
            return state.update(SHIFTS, list => list.set(index, data));
        }

        case shiftsActions.DELETE_BAR_REPORT_SHIFT_SUCCESS:
        case shiftsActions.FETCH_BAR_REPORT_SHIFTS_SUCCESS:
        case shiftsActions.ADD_BAR_REPORT_SHIFT_SUCCESS: {
            const {page, shifts, max} = action.payload.data;
            return state
                .set(PAGE, page)
                .set(SHIFTS, fromJS(shifts))
                .set(MAX, max);
        }

    }

    return state;
};

export default shiftsReducer;



// WEBPACK FOOTER //
// ./src/common/menu/report/shifts/reducer.js